
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7Tq4R", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $a2725444c60d8295$export$2cd8252107eb640b; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $9jv6U = parcelRequire("9jv6U");

var $01JF1 = parcelRequire("01JF1");

var $cGDYS = parcelRequire("cGDYS");

var $7RyUO = parcelRequire("7RyUO");

var $dunoe = parcelRequire("dunoe");

var $k2OeR = parcelRequire("k2OeR");

var $j0nzO = parcelRequire("j0nzO");

var $14zFQ = parcelRequire("14zFQ");

var $dJ4mM = parcelRequire("dJ4mM");

var $6wlNh = parcelRequire("6wlNh");

var $9uFWm = parcelRequire("9uFWm");

var $EyEcw = parcelRequire("EyEcw");

var $9Dbz6 = parcelRequire("9Dbz6");
window.BUILD_KEY = "p-69c1d38638";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $cGDYS.default)()
    }
};
const $a2725444c60d8295$export$2cd8252107eb640b = (Component)=>{
    const isStatic = typeof window !== "undefined" && window.IS_STATIC;
    const analyticsWebClient = (0, $dunoe.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $9Dbz6.parseRoute)(window.location);
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== "undefined") locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    const isPerfOnetrustEnabled = (0, $k2OeR.isPerformanceOnetrustEnabled)(typeof window !== "undefined" ? window.optanonConsentCookie : (0, $k2OeR.extractOptanonConsentCookie)(document.cookie), locationData);
    isPerfOnetrustEnabled && (0, $7RyUO.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $9jv6U.parse)(document.cookie) : {};
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $EyEcw.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    // Below is for debugging edge - will be removed
    window.ssrAnonId = window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
    // We can't feature gate below code as this is done before initialization so just overriding for the path we are testing
    if ((0, $6wlNh.isEdgeCachingPath)(window.location.pathname)) {
        // Override for Edge Caching
        (0, $6wlNh.overrideAjsAnonIdFromCookie)();
        (0, $6wlNh.overrideCustomAttributes)();
    }
    (0, $j0nzO.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(()=>{
        if (isStatic) {
            // @ts-ignore
            const root = (0, $01JF1.createRoot)(document.getElementById("wac"));
            root.render(/*#__PURE__*/ (0, $loA2J.jsx)((0, $9uFWm.SentryIntlProvider), {
                locale: locale,
                messages: window.SSR_languagePack,
                cookies: document.cookie,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dJ4mM.PageWrapper), {
                    analyticsWebClient: analyticsWebClient,
                    pureClientMode: true,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    countryCode: window.countryCode,
                    templates: window.templates,
                    partnerTemplates: window.partnerTemplates,
                    collections: window.collections,
                    categories: window.categories,
                    composition: window._uniformPreloadedComposition,
                    // @ts-ignore
                    compositionMetrics: window.compositionMetrics,
                    isUniformPlayground: window.isUniformPlayground,
                    isAllowPostMessage: window.isAllowPostMessage,
                    teamType: window.teamType,
                    keyword: window.keyword,
                    referrer: window.referrer,
                    mlTemplateIds: window.mlTemplateIds,
                    track: window.track,
                    anchor: window.anchor,
                    subAnchor: window.subAnchor,
                    clusterTag: window.clusterTag,
                    auxiaResponse: window.auxiaResponse,
                    transactionAccounts: window.transactionAccounts,
                    userAgent: userAgent,
                    children: Component
                })
            }));
        } else (0, $01JF1.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), /*#__PURE__*/ (0, $loA2J.jsx)((0, $9uFWm.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $14zFQ.Layout), {
                analyticsWebClient: analyticsWebClient,
                location: window.location,
                pricing: window.prices,
                availableProducts: window.availableProducts,
                // @ts-ignore
                tutorial: window.tutorial,
                templates: window.templates,
                partnerTemplates: window.partnerTemplates,
                collections: window.collections,
                categories: window.categories,
                userProfile: window.userProfile,
                userProfileStatus: window.userProfileStatus,
                userContext: window.userContext,
                userContextStatus: window.userContextStatus,
                loggedOutContext: window.loggedOutContext,
                loggedOutContextStatus: window.loggedOutContextStatus,
                countryCode: window.countryCode,
                composition: window._uniformPreloadedComposition,
                // @ts-ignore
                compositionMetrics: window.compositionMetrics,
                isUniformPlayground: window.isUniformPlayground,
                isAllowPostMessage: window.isAllowPostMessage,
                teamType: window.teamType,
                keyword: window.keyword,
                mlTemplateIds: window.mlTemplateIds,
                referrer: window.referrer,
                anchor: window.anchor,
                subAnchor: window.subAnchor,
                clusterTag: window.clusterTag,
                auxiaResponse: window.auxiaResponse,
                transactionAccounts: window.transactionAccounts,
                userAgent: userAgent,
                children: Component
            })
        }), {
            onRecoverableError: (error, errorInfo)=>{
                var _document_getElementById;
                (_document_getElementById = document.getElementById("wac-root")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.setAttribute("hydration-error", "true");
            }
        });
    });
};

});

parcelRegister("f0Hih", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("dhmEV")).default; });

var $dhmEV = parcelRequire("dhmEV");

});

parcelRegister("3XfGP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e130d715135cd6b$export$2e2bcd8739ae039; });

var $iB48s = parcelRequire("iB48s");

var $dQt1t = parcelRequire("dQt1t");

var $iSvIT = parcelRequire("iSvIT");

var $6IiXU = parcelRequire("6IiXU");

var $4WLmP = parcelRequire("4WLmP");
var $2e130d715135cd6b$var$_excluded = [
    "appearance",
    "isDisabled",
    "isSelected",
    "isLoading",
    "spacing"
];
/**
 * __Loading button__
 *
 * A small wrapper around Button that allows you to show an @atlaskit/spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * - [Examples](https://atlassian.design/components/button/examples#loading-button)
 */ var $2e130d715135cd6b$var$LoadingButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function LoadingButton(_ref, ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, spacing = _ref.spacing, rest = (0, $dQt1t.default)(_ref, $2e130d715135cd6b$var$_excluded);
    // Button already has React.memo, so just leaning on that
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $6IiXU.default), (0, $iB48s.default)({}, rest, {
        ref: ref,
        appearance: appearance,
        "aria-busy": isLoading,
        isDisabled: isDisabled,
        isSelected: isSelected,
        overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $4WLmP.default), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null,
        spacing: spacing
    }));
});
// Tools including enzyme rely on components having a display name
$2e130d715135cd6b$var$LoadingButton.displayName = "LoadingButton";
var $2e130d715135cd6b$export$2e2bcd8739ae039 = $2e130d715135cd6b$var$LoadingButton;

});
parcelRegister("4WLmP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39a15251825d0efd$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $8HJYY = parcelRequire("8HJYY");
function $39a15251825d0efd$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return "inherit";
    if (isSelected) return "invert";
    if (appearance === "primary" || appearance === "danger") return "invert";
    return "inherit";
}
function $39a15251825d0efd$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing;
    var size = spacing === "default" ? "medium" : "small";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $8HJYY.default), {
        size: size,
        appearance: $39a15251825d0efd$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});
parcelRegister("8HJYY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65660203519f4bc0$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $jkaxq = parcelRequire("jkaxq");

var $lG0aY = parcelRequire("lG0aY");

var $9c5Gg = parcelRequire("9c5Gg");

var $3lt1l = parcelRequire("3lt1l");
/**
 * Returns the appropriate circle stroke color.
 */ function $65660203519f4bc0$var$getStrokeColor(_ref) {
    var mode = _ref.mode, appearance = _ref.appearance;
    if (mode === "light") return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $lG0aY.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $lG0aY.N0), ")");
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $lG0aY.DN900), ")") : "var(--ds-icon-inverse, ".concat((0, $lG0aY.DN500), ")");
}
var $65660203519f4bc0$var$rotate = (0, $2ZUkg.keyframes)({
    to: {
        transform: "rotate(360deg)"
    }
});
var $65660203519f4bc0$var$rotateStyles = (0, $2ZUkg.css)({
    animation: "".concat($65660203519f4bc0$var$rotate, " 0.86s infinite"),
    animationTimingFunction: "cubic-bezier(0.4, 0.15, 0.6, 0.85)",
    transformOrigin: "center"
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $65660203519f4bc0$var$loadIn = (0, $2ZUkg.keyframes)({
    from: {
        transform: "rotate(50deg)",
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: "rotate(230deg)",
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $65660203519f4bc0$var$loadInStyles = (0, $2ZUkg.css)({
    animation: "".concat($65660203519f4bc0$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: "forwards",
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $65660203519f4bc0$var$wrapperStyles = (0, $2ZUkg.css)({
    display: "inline-flex",
    /**
   * Align better inline with text.
   */ verticalAlign: "middle"
});
var $65660203519f4bc0$var$circleStyles = (0, $2ZUkg.css)({
    fill: "none",
    strokeDasharray: 60,
    strokeDashoffset: "inherit",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    "@media screen and (forced-colors: active)": {
        filter: "grayscale(100%)",
        stroke: "CanvasText"
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $65660203519f4bc0$var$useLayoutEffect = typeof window === "undefined" ? (0, $iSvIT.useEffect) : (0, $iSvIT.useLayoutEffect);
var $65660203519f4bc0$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function Spinner(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "inherit" : _ref2$appearance, _ref2$delay = _ref2.delay, delay = _ref2$delay === void 0 ? 0 : _ref2$delay, interactionName = _ref2.interactionName, label = _ref2.label, _ref2$size = _ref2.size, providedSize = _ref2$size === void 0 ? "medium" : _ref2$size, testId = _ref2.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $3lt1l.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var _useGlobalTheme = (0, $9c5Gg.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var stroke = $65660203519f4bc0$var$getStrokeColor({
        mode: mode,
        appearance: appearance
    });
    var context = (0, $iSvIT.useContext)((0, $jkaxq.default));
    $65660203519f4bc0$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $2ZUkg.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $65660203519f4bc0$var$wrapperStyles,
            $65660203519f4bc0$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $2ZUkg.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label,
        css: $65660203519f4bc0$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        }
    }, (0, $2ZUkg.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $65660203519f4bc0$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));

});
parcelRegister("3lt1l", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $26f9d8295bdc29c4$export$4e9f1640bbe7a1a8; });
var $26f9d8295bdc29c4$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});




parcelRegister("53DZ3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3aec3f7c0e69d664$var$_react = $3aec3f7c0e69d664$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $3aec3f7c0e69d664$var$_statusWarning = $3aec3f7c0e69d664$var$_interopRequireDefault((parcelRequire("goemm")));
function $3aec3f7c0e69d664$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3aec3f7c0e69d664$var$WarningIcon = (props)=>/*#__PURE__*/ $3aec3f7c0e69d664$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $3aec3f7c0e69d664$var$_statusWarning.default
    }));
$3aec3f7c0e69d664$var$WarningIcon.displayName = "WarningIcon";
var $3aec3f7c0e69d664$var$_default = module.exports.default = $3aec3f7c0e69d664$var$WarningIcon;

});
parcelRegister("goemm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::435e803a057e79e21a0d31c5b12f3f81>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $beea06c80568ff37$var$_react = $beea06c80568ff37$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $beea06c80568ff37$var$_baseNew = $beea06c80568ff37$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $beea06c80568ff37$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $beea06c80568ff37$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $beea06c80568ff37$var$_react.default.createElement($beea06c80568ff37$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$beea06c80568ff37$var$StatusWarningIcon.displayName = "StatusWarningIcon";
var $beea06c80568ff37$var$_default = module.exports.default = $beea06c80568ff37$var$StatusWarningIcon;

});


parcelRegister("ciFJX", function(module, exports) {

$parcel$export(module.exports, "ServiceCollectionLogo", function () { return $9b5a68762b5c44f3$export$c75146d7e53859e0; });
/* service-collection-logo.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $5ohHq = parcelRequire("5ohHq");
const $9b5a68762b5c44f3$export$c75146d7e53859e0 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        viewBox: "0 0 224 64",
        fill: "none",
        className: (0, $esG4f.default)([
            "_4t3ickbl _v5641jnf _1bsb1wug _165tvbgk"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: (0, $5ohHq.wacToken)("color.extended.yellow300"),
                d: "m1.755 5.022 105.992 3.701-1.755 50.256L0 55.277z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: (0, $5ohHq.wacToken)("color.primary.black"),
                d: "M89.066 29.582c-1.204 0-1.818.87-1.972 2.586h3.866c-.128-1.792-.742-2.586-1.894-2.586Zm5.734 9.651c-1.254.461-2.97.794-4.685.794-5.3 0-7.68-2.33-7.68-6.682 0-4.172 2.304-7.142 6.707-7.142 4.352 0 6.144 2.944 6.144 7.142v.999h-8.09c.308 1.305 1.204 1.715 3.022 1.715 1.535 0 3.225-.23 4.582-.614v3.788ZM81.458 35.112v4.121c-.896.512-2.048.82-3.456.82-4.864 0-7.117-2.868-7.117-6.938 0-4.02 2.253-6.912 6.81-6.912 1.587 0 2.56.282 3.711.82v4.172a6.674 6.674 0 0 0-2.944-.64c-1.996 0-2.816 1.178-2.816 2.56 0 1.433.922 2.483 2.944 2.483 1.383 0 2.125-.205 2.868-.486ZM64.084 22.824c0-1.664 1.254-2.637 2.944-2.637 1.74 0 2.97.973 2.97 2.637 0 1.69-1.23 2.662-2.97 2.662-1.69 0-2.945-.973-2.945-2.662Zm.537 16.947V26.51h4.839v13.26H64.62ZM60.285 39.77h-6.707l-3.482-13.26h4.71l2.177 9.856 2.176-9.856h4.608l-3.482 13.26ZM46.21 33.345v6.426h-4.864V26.51h4.864v2.509c.691-1.792 1.767-2.79 3.507-2.688v4.966c-2.585-.18-3.507.333-3.507 2.048ZM33.665 29.582c-1.203 0-1.817.87-1.971 2.586h3.866c-.129-1.792-.743-2.586-1.895-2.586Zm5.735 9.651c-1.255.461-2.97.794-4.685.794-5.3 0-7.68-2.33-7.68-6.682 0-4.172 2.304-7.142 6.707-7.142 4.352 0 6.144 2.944 6.144 7.142v.999h-8.09c.307 1.305 1.203 1.715 3.021 1.715 1.536 0 3.226-.23 4.583-.614v3.788ZM26.055 34.497c0 3.482-1.972 5.555-6.836 5.555-2.97 0-5.12-.665-6.502-1.408v-4.608c1.562.717 4.506 1.51 6.451 1.51 1.178 0 1.613-.383 1.613-.998 0-.64-.512-.998-1.843-1.254-4.992-.82-6.426-2.79-6.426-5.35 0-3.303 2.432-5.274 6.887-5.274 2.355 0 4.582.512 6.016 1.28v4.454c-2.176-.819-4.685-1.357-6.144-1.357-1.101 0-1.664.333-1.664.973 0 .64.588.948 2.355 1.28 4.915.794 6.093 2.688 6.093 5.197ZM185 9.232c0-1.748-.936-2.576-3.549-3.146-1.453-.313-1.802-.644-1.802-1.104 0-.57.514-.827 1.471-.827 1.16 0 2.3.348 3.384.845V2.7c-.753-.387-1.931-.68-3.31-.68-2.593 0-3.934 1.123-3.934 2.981 0 1.471.679 2.65 3.364 3.164 1.6.33 1.931.588 1.931 1.122 0 .535-.331.845-1.471.845-1.305 0-2.867-.44-3.88-1.049v2.41c.809.405 1.875.846 3.862.846 2.832 0 3.934-1.25 3.934-3.108ZM213.299 2.17v10.024h2.132v-7.65l.901 2.041 3.017 5.61h2.685V2.168h-2.135v6.475l-.809-1.876-2.428-4.599h-3.363ZM199.728 2.17h-2.335v10.004h2.335V2.17ZM194.709 9.232c0-1.748-.939-2.576-3.55-3.146-1.453-.313-1.801-.644-1.801-1.104 0-.57.514-.827 1.47-.827 1.158 0 2.298.348 3.384.845V2.7c-.753-.387-1.931-.68-3.31-.68-2.592 0-3.936 1.123-3.936 2.981 0 1.471.682 2.65 3.364 3.164 1.6.33 1.931.588 1.931 1.122 0 .535-.331.845-1.471.845-1.305 0-2.867-.44-3.88-1.049v2.41c.809.405 1.875.846 3.862.846 2.832 0 3.937-1.25 3.937-3.108ZM159.166 2.17v10.024h4.798l.756-2.17h-3.201V2.168h-2.353ZM149.714 2.17v2.17h2.572v7.854h2.354V4.34h2.778V2.17h-7.704ZM144.768 8.699c-.441 0-.883-.074-1.288-.184l1.288-4.377 1.287 4.377c-.405.11-.845.184-1.287.184Zm1.544-6.529h-3.071l-3.493 10.005h2.666l.496-1.692a6.9 6.9 0 0 0 1.875.277 6.28 6.28 0 0 0 1.876-.277l.496 1.692h2.666L146.312 2.17ZM170.694 8.699c-.441 0-.883-.074-1.288-.184l1.288-4.377 1.287 4.377c-.422.11-.845.184-1.287.184Zm1.526-6.529h-3.071l-3.493 10.005h2.666l.496-1.692a6.902 6.902 0 0 0 1.876.277c.661 0 1.269-.091 1.875-.277l.496 1.692h2.666L172.22 2.17ZM206.587 8.699c-.44 0-.883-.074-1.288-.184l1.288-4.377 1.287 4.377c-.404.11-.827.184-1.287.184Zm1.544-6.529h-3.071l-3.493 10.005h2.666l.497-1.692a6.889 6.889 0 0 0 1.875.277c.661 0 1.269-.091 1.875-.277l.496 1.692h2.666L208.131 2.17Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: (0, $5ohHq.wacToken)("color.primary.black"),
                d: "M194.709 9.232c0-1.748-.919-2.576-3.55-3.146-1.453-.313-1.801-.644-1.801-1.104 0-.57.514-.827 1.47-.827 1.158 0 2.298.348 3.384.845V2.7a7.547 7.547 0 0 0-3.31-.68c-2.592 0-3.936 1.123-3.936 2.981 0 1.471.682 2.65 3.364 3.164 1.6.33 1.931.588 1.931 1.122 0 .535-.331.845-1.471.845a8.17 8.17 0 0 1-3.88-1.048v2.41c.809.404 1.875.845 3.862.845 2.814 0 3.916-1.25 3.937-3.108Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: (0, $5ohHq.wacToken)("color.neutral.light1000"),
                d: "M222.104 32.39v7.68h-2.254v-7.916c0-2.359-.944-3.408-3.093-3.408-2.097 0-3.539 1.39-3.539 4.037v7.287h-2.254V26.964h2.254v2.15c.839-1.547 2.385-2.412 4.142-2.412 3.014 0 4.744 2.07 4.744 5.688ZM202.158 40.332c-3.932 0-6.239-2.91-6.239-6.841 0-3.932 2.307-6.79 6.239-6.79 3.906 0 6.186 2.858 6.186 6.79s-2.28 6.841-6.186 6.841Zm0-11.533c-2.805 0-4.037 2.202-4.037 4.692s1.232 4.744 4.037 4.744c2.779 0 3.984-2.254 3.984-4.744 0-2.49-1.205-4.692-3.984-4.692ZM190.629 23.504c0-.996.655-1.573 1.573-1.573.917 0 1.572.577 1.572 1.573s-.655 1.573-1.572 1.573c-.918 0-1.573-.577-1.573-1.573Zm.419 16.566V26.964h2.255V40.07h-2.255ZM184.671 36.007c0 1.154.682 1.94 2.071 1.94.524 0 1.022-.105 1.416-.183v2.175c-.394.105-.839.21-1.521.21-2.805 0-4.168-1.651-4.168-4.09v-6.998h-2.123v-2.097h2.123v-2.778h2.202v2.778h3.487v2.097h-3.487v6.946ZM178.978 37.711v2.019c-.786.419-1.992.602-3.198.602-4.665 0-6.841-2.83-6.841-6.841 0-3.958 2.176-6.79 6.841-6.79 1.18 0 2.097.158 3.12.63v2.097c-.839-.393-1.73-.63-2.962-.63-3.408 0-4.797 2.15-4.797 4.693 0 2.543 1.415 4.692 4.849 4.692 1.337 0 2.176-.184 2.988-.472ZM161.274 28.747c-2.385 0-3.591 1.546-3.827 3.827h7.313c-.131-2.438-1.232-3.827-3.486-3.827Zm5.033 10.8c-1.075.576-2.726.785-4.063.785-4.902 0-7.051-2.83-7.051-6.841 0-3.958 2.202-6.79 6.186-6.79 4.037 0 5.662 2.806 5.662 6.79v1.022h-9.568c.315 2.228 1.757 3.67 4.85 3.67 1.52 0 2.804-.288 3.984-.708v2.071ZM153.938 40.044c-.183.053-.576.105-1.153.105-2.149 0-3.513-1.022-3.513-3.434v-15.23h2.255v14.968c0 1.18.786 1.599 1.756 1.599.236 0 .393 0 .655-.026v2.018ZM147.103 40.044c-.183.053-.576.105-1.153.105-2.149 0-3.512-1.022-3.512-3.434v-15.23h2.254v14.968c0 1.18.786 1.599 1.756 1.599.236 0 .393 0 .655-.026v2.018ZM133.632 40.332c-3.932 0-6.239-2.91-6.239-6.841 0-3.932 2.307-6.79 6.239-6.79 3.905 0 6.186 2.858 6.186 6.79s-2.281 6.841-6.186 6.841Zm0-11.533c-2.805 0-4.037 2.202-4.037 4.692s1.232 4.744 4.037 4.744c2.778 0 3.984-2.254 3.984-4.744 0-2.49-1.206-4.692-3.984-4.692ZM125.74 37.03v2.28c-1.075.708-2.779 1.022-4.561 1.022-5.662 0-8.86-3.407-8.86-8.833 0-5.243 3.198-8.913 8.807-8.913 1.678 0 3.355.315 4.587 1.206v2.28c-1.232-.786-2.595-1.205-4.587-1.205-4.036 0-6.448 2.674-6.448 6.632 0 3.958 2.49 6.58 6.579 6.58 1.809 0 3.224-.42 4.483-1.05Z"
            })
        ]
    });
const $9b5a68762b5c44f3$var$logoCss = null;

});

parcelRegister("9jWQb", function(module, exports) {

$parcel$export(module.exports, "useUFOComponentExperience", function () { return $6c9387eaef4d4c57$export$30ab340faaed55d4; });

var $iSvIT = parcelRequire("iSvIT");
var $6c9387eaef4d4c57$var$useConstructor = function useConstructor(callback) {
    var hasBeenFired = (0, $iSvIT.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
var $6c9387eaef4d4c57$export$30ab340faaed55d4 = function useUFOComponentExperience(experience) {
    (0, $iSvIT.useEffect)(function() {
        return function() {
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $6c9387eaef4d4c57$var$useConstructor(function() {
        return experience.start();
    });
    return null;
};

});

parcelRegister("hjMWG", function(module, exports) {

$parcel$export(module.exports, "Adg4Skeleton", function () { return $74c1b43210cd442a$export$e754784845e8828d; });

var $7Knp0 = parcelRequire("7Knp0");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $g2OHD = parcelRequire("g2OHD");

var $kwHar = parcelRequire("kwHar");

var $5ohHq = parcelRequire("5ohHq");
const $74c1b43210cd442a$export$e754784845e8828d = (_param)=>{
    var { width: width, height: height, groupName: groupName, testId: testId } = _param, props = (0, $akGnX._)(_param, [
        "width",
        "height",
        "groupName",
        "testId"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g2OHD.default), (0, $7Knp0._)({
        width: width,
        height: height,
        groupName: groupName,
        testId: testId,
        isShimmering: true,
        borderRadius: (0, $kwHar.default)("space.100"),
        color: (0, $5ohHq.wacToken)("color.neutral.light200"),
        ShimmeringEndColor: (0, $5ohHq.wacToken)("color.neutral.light300")
    }, props));
};

});
parcelRegister("g2OHD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bae429c214074d74$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8TInU = parcelRequire("8TInU");

var $1tzue = parcelRequire("1tzue");

var $iSvIT = parcelRequire("iSvIT");

var $b8Gks = parcelRequire("b8Gks");
var $k1KzN = parcelRequire("k1KzN");
function $bae429c214074d74$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bae429c214074d74$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bae429c214074d74$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1tzue.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bae429c214074d74$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $bae429c214074d74$var$shimmerKeyframes = null;
var $bae429c214074d74$var$skeletonStyles = null;
var $bae429c214074d74$var$activeShimmerStyles = null;
/**
 * __Skeleton__
 *
 * A skeleton acts as a placeholder for content, usually while the content loads.
 *
 * - [Examples](https://atlassian.design/components/skeleton/examples)
 * - [Code](https://atlassian.design/components/skeleton/code)
 */ var $bae429c214074d74$var$Skeleton = function Skeleton(_ref) {
    var width = _ref.width, height = _ref.height, _ref$borderRadius = _ref.borderRadius, borderRadius = _ref$borderRadius === void 0 ? "100px" : _ref$borderRadius, color = _ref.color, ShimmeringEndColor = _ref.ShimmeringEndColor, _ref$isShimmering = _ref.isShimmering, isShimmering = _ref$isShimmering === void 0 ? false : _ref$isShimmering, groupName = _ref.groupName, testId = _ref.testId;
    var groupDataAttribute = groupName && "data-".concat(groupName);
    return /*#__PURE__*/ $iSvIT.createElement("div", (0, $8TInU.default)({
        "data-testid": testId
    }, groupDataAttribute && (0, $1tzue.default)({}, groupDataAttribute, "true"), {
        className: (0, $b8Gks.default)([
            "_7hjf1yy8 _5sag12o8 _tip812c5 _1pglp3kn _bfhkn82g",
            isShimmering && "",
            isShimmering && "_j7hq586c"
        ]),
        style: $bae429c214074d74$var$_objectSpread($bae429c214074d74$var$_objectSpread({}, {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            "--ds-skeleton-from-color": color && ShimmeringEndColor ? color : undefined,
            "--ds-skeleton-to-color": color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        }), {}, {
            "--_wenvhl": (0, $k1KzN.default)("var(--ds-skeleton-from-color, ".concat("var(--ds-skeleton, #091E420F)", ")")),
            "--_1soe2er": (0, $k1KzN.default)("var(--ds-skeleton-to-color, ".concat("var(--ds-skeleton-subtle, #091E4208)", ")"))
        })
    }));
};
var $bae429c214074d74$export$2e2bcd8739ae039 = $bae429c214074d74$var$Skeleton;

});
parcelRegister("8TInU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67a5e3a84d125062$export$2e2bcd8739ae039; });
function $67a5e3a84d125062$export$2e2bcd8739ae039() {
    return $67a5e3a84d125062$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $67a5e3a84d125062$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("1tzue", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $113406c6bdee5322$export$2e2bcd8739ae039; });

var $k4PRg = parcelRequire("k4PRg");
function $113406c6bdee5322$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $k4PRg.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("k4PRg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9dc684bfecaec5f$export$2e2bcd8739ae039; });

var $1bWKL = parcelRequire("1bWKL");

var $75jqn = parcelRequire("75jqn");
function $e9dc684bfecaec5f$export$2e2bcd8739ae039(t) {
    var i = (0, $75jqn.default)(t, "string");
    return "symbol" == (0, $1bWKL.default)(i) ? i : i + "";
}

});
parcelRegister("1bWKL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0de464af02e7f83b$export$2e2bcd8739ae039; });
function $0de464af02e7f83b$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $0de464af02e7f83b$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0de464af02e7f83b$export$2e2bcd8739ae039(o);
}

});

parcelRegister("75jqn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $528811526f37b7b7$export$2e2bcd8739ae039; });

var $1bWKL = parcelRequire("1bWKL");
function $528811526f37b7b7$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $1bWKL.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $1bWKL.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("b8Gks", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81c146b95d18c9fb$export$2e2bcd8739ae039; });
const $81c146b95d18c9fb$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $81c146b95d18c9fb$var$ATOMIC_GROUP_LENGTH = 5;
function $81c146b95d18c9fb$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $81c146b95d18c9fb$var$UNDERSCORE_UNICODE ? $81c146b95d18c9fb$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("k1KzN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e94807bc1aa32f2f$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $e94807bc1aa32f2f$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return "var(--c-, )";
}

});



parcelRegister("ctYD4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9167392384132023$var$_react = $9167392384132023$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $9167392384132023$var$_baseNew = $9167392384132023$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $9167392384132023$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9167392384132023$var$CommentIcon = (props)=>/*#__PURE__*/ $9167392384132023$var$_react.default.createElement($9167392384132023$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$9167392384132023$var$CommentIcon.displayName = "CommentIcon";
var $9167392384132023$var$_default = module.exports.default = $9167392384132023$var$CommentIcon;

});

parcelRegister("30lzE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e0a5e9b0b4b1b954a0d2b89a777fbfe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23021b54e58d1b56$var$_react = $23021b54e58d1b56$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $23021b54e58d1b56$var$_baseNew = $23021b54e58d1b56$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $23021b54e58d1b56$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Roadmap".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $23021b54e58d1b56$var$RoadmapIcon = (props)=>/*#__PURE__*/ $23021b54e58d1b56$var$_react.default.createElement($23021b54e58d1b56$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM3 11a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$23021b54e58d1b56$var$RoadmapIcon.displayName = "RoadmapIcon";
var $23021b54e58d1b56$var$_default = module.exports.default = $23021b54e58d1b56$var$RoadmapIcon;

});

parcelRegister("cm6I6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7831691c1245bdf104acebfc690a968c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8fecbea8f909d674$var$_react = $8fecbea8f909d674$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $8fecbea8f909d674$var$_baseNew = $8fecbea8f909d674$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $8fecbea8f909d674$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8fecbea8f909d674$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $8fecbea8f909d674$var$_react.default.createElement($8fecbea8f909d674$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3.5c-2.943 0-5.49 1.845-6.424 4.396a.3.3 0 0 0 0 .208C2.509 10.655 5.057 12.5 8 12.5s5.49-1.845 6.424-4.396a.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5M.167 7.38C1.32 4.232 4.433 2 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24C14.68 11.768 11.566 14 8 14 4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$8fecbea8f909d674$var$EyeOpenIcon.displayName = "EyeOpenIcon";
var $8fecbea8f909d674$var$_default = module.exports.default = $8fecbea8f909d674$var$EyeOpenIcon;

});

parcelRegister("3uD1D", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86c9de42fef4ccbc35a6164a0094138a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28b2720e9e231e40$var$_react = $28b2720e9e231e40$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $28b2720e9e231e40$var$_baseNew = $28b2720e9e231e40$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $28b2720e9e231e40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $28b2720e9e231e40$var$LockLockedIcon = (props)=>/*#__PURE__*/ $28b2720e9e231e40$var$_react.default.createElement($28b2720e9e231e40$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$28b2720e9e231e40$var$LockLockedIcon.displayName = "LockLockedIcon";
var $28b2720e9e231e40$var$_default = module.exports.default = $28b2720e9e231e40$var$LockLockedIcon;

});

parcelRegister("iHmgk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aedef9bb726854d64999097926d2fc86>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d9cd82fde84d01f4$var$_react = $d9cd82fde84d01f4$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $d9cd82fde84d01f4$var$_baseNew = $d9cd82fde84d01f4$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $d9cd82fde84d01f4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAvatar".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d9cd82fde84d01f4$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $d9cd82fde84d01f4$var$_react.default.createElement($d9cd82fde84d01f4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0-4.148 11.505A2.75 2.75 0 0 1 6.5 11h3c1.26 0 2.323.848 2.648 2.005A6.5 6.5 0 0 0 8 1.5m2.75 12.392v-.142c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v.142l.06.027c.82.373 1.73.581 2.69.581s1.87-.208 2.69-.58q.03-.016.06-.028M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3.5 2a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" clip-rule="evenodd"/>`
    }, props));
$d9cd82fde84d01f4$var$PersonAvatarIcon.displayName = "PersonAvatarIcon";
var $d9cd82fde84d01f4$var$_default = module.exports.default = $d9cd82fde84d01f4$var$PersonAvatarIcon;

});

parcelRegister("guk0p", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7de7c2be3f7c9d9cc79e629bb0768f3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c00ef75bf5693ff4$var$_react = $c00ef75bf5693ff4$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $c00ef75bf5693ff4$var$_baseNew = $c00ef75bf5693ff4$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $c00ef75bf5693ff4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Timeline".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for timelines in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c00ef75bf5693ff4$var$TimelineIcon = (props)=>/*#__PURE__*/ $c00ef75bf5693ff4$var$_react.default.createElement($c00ef75bf5693ff4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11 2.5H1V1h10zm4 4.167H5v-1.5h10zm-4 4.167H1v-1.5h10zM15 15H5v-1.5h10z" clip-rule="evenodd"/>`
    }, props));
$c00ef75bf5693ff4$var$TimelineIcon.displayName = "TimelineIcon";
var $c00ef75bf5693ff4$var$_default = module.exports.default = $c00ef75bf5693ff4$var$TimelineIcon;

});


var $7Tq4R = parcelRequire("7Tq4R");

var $b45Um = parcelRequire("b45Um");
(0, $7Tq4R.init)((0, $b45Um.SignupPage));


//# sourceMappingURL=signup-page.45440bdf.js.map
